'use strict';

var chunk4KU4GBKR_js = require('../chunk-4KU4GBKR.js');
var chunkT2XIRJIF_js = require('../chunk-T2XIRJIF.js');
require('../chunk-BFWPR76Y.js');
require('../chunk-G7XVAAZO.js');
require('../chunk-ZGQXM674.js');
require('../chunk-RX6S2VJY.js');
require('../chunk-FYGG567E.js');
require('../chunk-WNNKWDCR.js');
require('../chunk-TRTE636W.js');
require('../chunk-M5MKKXBY.js');
require('../chunk-ATB4Z7GO.js');
require('../chunk-7GTRMEIW.js');
require('../chunk-GWPDT7BR.js');
require('../chunk-U3QCK4FI.js');
require('../chunk-3CUP7X6U.js');
require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var n = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var n__default = /*#__PURE__*/_interopDefault(n);

var m=({dropdownData:a})=>{let{heading:t,dropdownOptions:o,navLinks:s=[]}=a||{};return o?n__default.default.createElement(chunkT2XIRJIF_js.a,{dropdownOptions:o}):n__default.default.createElement(chunk4KU4GBKR_js.a,{heading:t,links:s})};

exports.DesktopNavbarDropdown = m;
